import axios from 'axios';

export default {
  get: (params) => axios.get('/api/v1/dynamic-data-structure', { params }),
  getById: (id) => axios.get(`/api/v1/dynamic-data-structure/${id}`),
  removeDataStructure: (id) => axios.delete(`/api/v1/dynamic-data-structure?ids[]=${id}`),
  createDataStructure: (params) => axios.post('/api/v1/dynamic-data-structure', params),
  updateDataStructure: (id, params) => axios.put(`/api/v1/dynamic-data-structure/${id}`, params),
  getContentItemsByStructureId: (structureId, params) => axios.get(`/api/v1/dynamic-data-storage-list/${structureId}`, { params }),
  getContentItemById: (itemId) => axios.get(`/api/v1/dynamic-data-storage/${itemId}`),
  createContentItem: (params) => axios.post('/api/v1/dynamic-data-storage', params),
  updateContentItem: (itemId, params) => axios.put(`/api/v1/dynamic-data-storage/${itemId}`, params),
  removeContentItem: (itemId) => axios.delete(`/api/v1/dynamic-data-storage?ids[]=${itemId}`),
};